/**
 * Admin auth helpers — JWT token stored in localStorage + axios with bearer.
 */
import axios from "axios";
import { API } from "./api";

const TOKEN_KEY = "ags_admin_token";

export function getAdminToken() {
  try { return localStorage.getItem(TOKEN_KEY) || ""; } catch (e) { return ""; }
}

export function setAdminToken(t) {
  try { localStorage.setItem(TOKEN_KEY, t); } catch (e) { /* ignore */ }
}

export function clearAdminToken() {
  try { localStorage.removeItem(TOKEN_KEY); } catch (e) { /* ignore */ }
}

export const adminApi = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
  const t = getAdminToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      clearAdminToken();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  },
);

export async function adminLogin(email, password) {
  const { data } = await adminApi.post("/admin/login", { email, password });
  if (data?.access_token) setAdminToken(data.access_token);
  return data;
}

export async function adminMe() {
  const { data } = await adminApi.get("/admin/me");
  return data;
}

export async function adminLogout() {
  try { await adminApi.post("/admin/logout"); } catch (e) { /* ignore */ }
  clearAdminToken();
}
